<script>
const www_img = "https://mscyeserver.mscye.com";
const apiurl = "https://mscyeserver.mscye.com/webstf.php/webStfapi";

export default {
  www_img,
  apiurl
};
</script>



// WEBPACK FOOTER //
// src/components/common.vue